import * as React from 'react';
import * as i18n from 'i18next';
const { connect } = require('react-redux');
import { browserHistory } from 'react-router';
import { IStore } from 'redux/IStore';
import { IAuthContext } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { Button } from 'components';

interface IProps {
	message: any;
	location?: any;
	baseUrlClient?: string;
	context?: IAuthContext;
	isSummary?: boolean; // adds top padding and go back button if false
}

@connect(
	(store: IStore) => ({ baseUrlClient: store.fetchDefault.baseUrlClient }),
	(dispatch) => ({
		dispatch,
	}),
)
class ErrorPageComponent extends React.Component<IProps, {}> {
	constructor(props: IProps) {
		super(props);
	}

	componentDidMount(): void {
		const magazineUrl = this.props.baseUrlClient + '/magazine';

		if (browserHistory) {
			if (this.props.message && (this.props.message.status === 500 || this.props.message.status === 503)) {
				if (window.location.href.startsWith(magazineUrl)) {
					browserHistory.replace('/magazine/500');
				} else {
					browserHistory.replace('/500');
				}
			} else if (this.props.message && this.props.message.status === 404) {
				if (window.location.href.startsWith(magazineUrl)) {
					browserHistory.replace('/magazine/404');
				} else {
					browserHistory.replace('/404');
				}
			}
		}
	}

	public render() {
		const { message } = this.props;
		if (message && (message.status === 401 || message.status === 403)) {
			this.props.context.signinRedirect();
		}

		const errorSectionElement: JSX.Element = (
			<div className="errorSection">
				{!this.props.message.error ? (
					!this.props.message.status ? (
						<p className="errorSection__text">{i18n.t('Error_Generic')}</p>
					) : (
						<p className="errorSection__text">
							{i18n.t('ErrorPage_ErrorLabel')}: {this.props.message.status} {this.props.message.statusText}
						</p>
					)
				) : (
					<p className="errorSection__text">{this.props.message.error}</p>
				)}
			</div>
		);

		if (this.props?.isSummary) {
			return errorSectionElement;
		}

		return (
			<div className="errorSectionContainer topPadding">
				<div className="errorSection">
					{!this.props.message.error ? (
						!this.props.message.status ? (
							<p className="errorSection__text">{i18n.t('Error_Generic')}</p>
						) : (
							<p className="errorSection__text">
								{i18n.t('ErrorPage_ErrorLabel')}: {this.props.message.status} {this.props.message.statusText}
							</p>
						)
					) : (
						<p className="errorSection__text">{this.props.message.error}</p>
					)}
				</div>
				<div className="errorSectionButtons">
					<Button
						size="small"
						onClick={() => {
							history.go(-2);
						}}
					>
						{i18n.t('ErrorPage404_Home')}
					</Button>
				</div>
			</div>
		);
	}
}

const ErrorPage = withAuthContext(ErrorPageComponent);

export { ErrorPage };
